import type { Dispatch, SetStateAction } from 'react'
import type { MemberPortalProfile, ProfileDraft } from './MemberPortalProfile'

export function toDraft(profile: MemberPortalProfile): ProfileDraft {
  return {
    name: profile.name,
    phone: profile.phone ?? '',
    addressLine1: profile.address_line1 ?? '',
    addressLine2: profile.address_line2 ?? '',
    city: profile.city ?? '',
    region: profile.region ?? '',
    postalCode: profile.postal_code ?? '',
    countryCode: profile.country_code ?? '',
    customFields: Object.fromEntries(
      profile.custom_fields.map((field) => [String(field.id ?? field.label), field.value]),
    ),
  }
}

export function editableCustomFields(
  profile: MemberPortalProfile | undefined,
  values: Record<string, string | boolean>,
) {
  if (!profile) return {}
  return Object.fromEntries(
    profile.custom_fields
      .filter((field) => field.field_access === 'member_edit')
      .map((field) => {
        const key = String(field.id ?? field.label)
        return [key, values[key]]
      }),
  )
}

export function setCustomField(
  setDraft: Dispatch<SetStateAction<ProfileDraft | null>>,
  draft: ProfileDraft,
  key: string,
  value: string,
) {
  setDraft({ ...draft, customFields: { ...draft.customFields, [key]: value } })
}

export function profileValue(value: string | boolean | undefined) {
  if (value === undefined || value === '') return ''
  return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value
}
